/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'reportTokens';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'reportToken';

/** Singular entity name for `createCrudModel` reducers/notifications. Often equals `FETCH_ROUTE`. */
export const ENTITY_NAME = 'token';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'reportTokens';

/** Default list sort — matches legacy `useManageReportTokens`. */
export const DEFAULT_ORDER_BY = 'token asc';
